import { render } from "./GuoCangFooter.vue?vue&type=template&id=888a0808&ts=true"
import script from "./GuoCangFooter.vue?vue&type=script&lang=ts"
export * from "./GuoCangFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__